import service from '@/store/services/workshop/daily_closing-service';

const state = {
  list: {},
  daily_closing: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => { 
    state.list = list;
  },
  SET_RESOURCE: (state, daily_closing) => {
    state.daily_closing = daily_closing;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((daily_closing) => { commit('SET_RESOURCE', daily_closing); });
  },


  add({commit, dispatch}, params) {
    return service.add(params)
      .then((daily_closing) => { commit('SET_RESOURCE', daily_closing); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((daily_closing) => { commit('SET_RESOURCE', daily_closing); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  daily_closing: state => state.daily_closing,
  page: state => state.meta.page,
};
 
const daily_closing = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default daily_closing;
